export default "__VITE_ASSET__9d5fc0ae__"